import { Component, OnChanges, inject, ChangeDetectionStrategy, input, output } from '@angular/core';
import {GuruEntity} from '../../../model/guru-entity';
import {ConfigurationSection, UserStateService} from '../../../services/user-state.service';
import {ModelService} from '../../../services/model-service';
import {SelectionUtils} from '../../selection-utils';
import { FormsModule } from '@angular/forms';

import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-belt-drive-controls',
    templateUrl: './belt-drive-controls.component.html',
    styleUrls: ['./belt-drive-controls.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, FormsModule]
})
export class BeltDriveControlsComponent implements OnChanges {
  private modelService = inject(ModelService);
  private userStateService = inject(UserStateService);


  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  readonly unitTypeChanged = output<void>();
  readonly systemTypeChanged = output<void>();
  controlVoltageSelection!: GuruEntity;
  thermostatTypeSelection!: GuruEntity;
  controlTypeSelection!: GuruEntity;
  condensateSwitchSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.CONTROLS;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.controlVoltageSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USControlVoltage');
    this.thermostatTypeSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USThermostat');
    this.controlTypeSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USControlType');
    this.condensateSwitchSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCondensateSwitch');
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
